import moment from 'moment';
import unset from 'lodash/unset';
import cloneDeep from 'lodash/cloneDeep';
import { DEFAULT_VALUE } from './constants/index';

export const getValueOrDefaultValue = (value, defaultValue) => {
  if ([null, undefined, ''].includes(value)) return defaultValue || DEFAULT_VALUE;
  return value || DEFAULT_VALUE;
};

export const extractChangedValues = (current, previous) => {
  return Object.keys(current).reduce((acc, key) => {
    if (current[key] !== previous[key]) {
      acc[key] = current[key];
    }
    return acc;
  }, {});
};

export const removeKey = (raw, key, nested = false) => {
  if (!raw) return raw;
  const result = Array.isArray(raw) ? [...raw] : { ...raw };

  if (Array.isArray(result)) {
    result.map((item) => removeKey(item, key, nested));
  }
  if (typeof result === 'object' && !!result) {
    if (nested) {
      Object.keys(result).forEach((k) => {
        if (k === key) {
          delete result[k];
        }
        if (typeof result[k] === 'object' && !!result[k]) {
          result[k] = removeKey(result[k], key, nested);
        }
      });
    } else {
      delete result[key];
    }
  }
  return result;
};

export function removeByPath(obj, paths) {
  paths.forEach((path) => {
    const keys = path.split('.');
    let current = obj;

    for (let i = 0; i < keys.length - 1; i++) {
      if (Array.isArray(current[keys[i]])) {
        // If the current key is an array, apply the logic to each element
        current[keys[i]].forEach((item) => removeByPath(item, [keys.slice(i + 1).join('.')]));
        return; // Exit the loop as the recursion handles the rest
      }

      if (current[keys[i]] === undefined || current[keys[i]] === null) {
        return; // Path does not exist, skip
      }

      current = current[keys[i]];
    }

    delete current[keys[keys.length - 1]];
  });

  return obj;
}

export const castToMoment = (dateString, fallbackToToday = false) => {
  if (moment.isMoment(dateString)) return dateString;
  if (dateString) {
    return moment(dateString);
  }
  if (fallbackToToday) {
    return moment();
  }
  return null;
};

export * from './file';
